import { Tabs, TabsProps } from "antd"
import { useState } from "react"
import { EmailTemplateType, EmailTemplateTypes } from "../../common/constants"
import EmailTemplateTypeList from "./EmailTemplateTypeList"

type Props = {
  onChangesPending?: (hasChanges:boolean) => void
}

const EmailTemplateList = ({ onChangesPending }: Props) => {
  const [activeTab, setActiveTab] = useState<string>(EmailTemplateTypes.Consultation.toString())
  const items: TabsProps['items'] = [
    {
      key: EmailTemplateTypes.Consultation.toString(),
      label: 'Consultations'
    },
    {
      key: EmailTemplateTypes.Proposal.toString(),
      label: 'Proposals'
    },
  ]

  return <>
    <Tabs activeKey={activeTab} onChange={setActiveTab} items={items} />
    <EmailTemplateTypeList emailTemplateType={Number(activeTab) as EmailTemplateType} onChangesPending={onChangesPending} />
  </>
}

export default EmailTemplateList
